<template>
  <div class="massLoss-list">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: type === 0 }">运输</div>
      <div @click="typeFun(1)" class="right" :class="{ active: type === 1 }">库场</div>
    </div>
    <div class="nav" v-if="type === 0">
      <el-form :model="searchForm" label-width="110px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="原对账单标题：">
          <el-input v-model="searchForm.title" size="mini" placeholder="请输入原对账单标题" />
        </el-form-item>
        <el-form-item label="运单编号：">
          <el-input v-model="searchForm.waybillNo" size="mini" placeholder="请输入运单编号" />
        </el-form-item>
        <el-form-item label="车架号：">
          <el-input v-model="searchForm.frameNumber" size="mini" placeholder="请输入车架号"  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <!-- <el-button size="small" type="primary" @click="recordAdjust">对账调整</el-button> -->
          <el-button size="small" type="primary" @click="newBtn">新增</el-button>
          <el-button size="small" type="primary" @click="onClickBtnDeletes">批量删除</el-button>
          <el-button size="small" type="primary" @click="onClickGenerateStatementAccount">生成对账单</el-button>
          <!-- <el-button size="small" type="primary" @click="generateDeductionFees">生成抵扣费用</el-button> -->
          <div style="display: inline-block; margin-left: 10px;">
            <batch-import :uploadUrl="'/customer/adjust/imports'" :uploadText="'抵扣费用批量导入'" :is-button="true"
                        :button-size="'small'" @importSuccess='searchBtn' @triggerLoading='importLoading = !importLoading'/>
            <batch-import :uploadUrl="'/customer/adjust/importss'" :uploadText="'对账单批量导入'" :is-button="true"
                        :button-size="'small'" @importSuccess='searchBtn' @triggerLoading='importLoading = !importLoading'/>
          </div>

        </el-form-item>
      </el-form>
    </div>
    <el-row v-if="type === 0">
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="download" class="pointer">模板下载</span>
        <span @click='exportData'>导出数据</span>
        <span style='cursor: pointer;display: inline-block;' >
          <batch-import :uploadUrl="'/customer/adjust/import'" :uploadText="'同价格批量导入'"  @importSuccess='searchBtn' @triggerLoading='importLoading = !importLoading' />
        </span>
        <span style='cursor: pointer;display: inline-block;' >
          <batch-import :uploadUrl="'/customer/adjust/importDiff'" :uploadText="'不同价格批量导入'"  @importSuccess='searchBtn' @triggerLoading='importLoading = !importLoading' />
        </span>
      </el-col>
    </el-row>
    <div class="content" v-if="type === 0">
      <div class="tableContainer">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          :data="tableData"
          style="width: 100%"
          border
          :header-cell-style="headerCellStyle"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
          :row-key="
            row => {
              return row.id;
            }
          "
          :row-style="rowStyle">
          <el-table-column
            type="selection"
            align="center"
            min-width="80px"
            :selectable="
              row => {
                return row.isReconciliation == 0;
              }
            " />
          <!-- <el-table-column prop="typeStr" label="结算类型" align="center" min-width="180px" />
          <el-table-column prop="title" label="对账单标题" align="center" min-width="150px" />
          <el-table-column prop="companyName" label="公司名称" align="center" min-width="220px" />
          <el-table-column prop="batchNumber" label="批次号" align="center" min-width="180px" />
          <el-table-column prop="waybillNo" label="运单编号" align="center" min-width="140px" />
          <el-table-column prop="frameNumber" label="车架号" align="center" min-width="200px" />
          <el-table-column prop="workType" label="运输方式/作业类型" align="center" min-width="140px" />
          <el-table-column prop="taxRate" label="税率" align="center" min-width="120px" />
          <el-table-column prop="taxPrice" label="含税费用" align="center" min-width="120px" />
          <el-table-column prop="status" label="开票状态" align="center" min-width="120px" />
          <el-table-column prop="taxAdjustRate" label="对账调整税率" align="center" min-width="120px" />
          <el-table-column prop="taxAdjustPrice" label="对账调整含税费用" align="center" min-width="140px" /> -->
          <el-table-column prop="setNo" label="原对账单编号" align="center" min-width="180px" />
          <el-table-column prop="title" label="原对账单标题" align="center" min-width="180px" />
          <!-- <el-table-column prop="type" label="原来账单类型" align="center" min-width="180px" /> -->
          <el-table-column prop="setType" label="结算类型" align="center" min-width="180px">
            <template slot-scope="scope">{{ scope.row.setType == 1 ? '合同价' : '预结算价' }}</template>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" min-width="180px" />
          <el-table-column prop="batchNumber" label="批次号" align="center" min-width="180px" />
          <el-table-column prop="waybillNo" label="运单编号" align="center" min-width="180px" />
          <el-table-column prop="frameNumber" label="车架号" align="center" min-width="180px" />
          <el-table-column prop="taxRate" label="税率" align="center" min-width="180px" />
          <el-table-column prop="taxPrice" label="含税单价" align="center" min-width="180px" />
          <el-table-column prop="taxAdjustPrice" label="对账调整含税价格" align="center" min-width="180px" />
          <el-table-column prop="isReconciliation" label="是否生成对账单/是否生成抵扣费用" align="center" min-width="130px">
            <template slot-scope="scope">{{ scope.row.isReconciliation == 1 ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="actTitle" label="对账单标题" align="center" min-width="180px" />
          <el-table-column prop="actNo" label="对账单编号" align="center" min-width="180px" />
          <el-table-column prop="discountNo" label="抵扣费用编号" align="center" min-width="180px" />
          <el-table-column prop="createBy" label="录入人员" align="center" min-width="180px" />
          <el-table-column prop="createdTime" label="创建时间" align="center" min-width="180px" />
          <el-table-column label="操作" width="310" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="onClickEdit(scope.row)">修改</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="onClickDelete(scope.row.id)">删除</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="onClickSubmitReconciliation(scope.row)">提交对账</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="cancelReferClick(scope.row.id)">取消对账</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>

    <record-adjust-form ref="recordAdjustFormRef" @searchBtn="searchBtn" />
    <newDialog ref="newDialogRef" />
    <el-dialog title="修改" :visible.sync="dialogVisibleEdit" width="900px" center @close="dialogCloseEdit" :close-on-click-modal="false" top="10vh">
      <div class="company" v-loading="formLoadingEdit">
        <el-form :model="modifyData" label-width="150px" ref="ruleForm">
          <div-border label="基础信息" prop="infor">
            <el-form-item label="原对账单编号：" prop="setNo">
              <el-input placeholder="请输入内容" v-model="modifyData.setNo" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="原来账单类：" prop="type">
              <el-input placeholder="请输入内容" v-model="modifyData.type" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="结算类型：" prop="setType">
              <el-input placeholder="请输入内容" v-model="modifyData.setType" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="公司名称：" prop="companyName">
              <el-input placeholder="请输入内容" v-model="modifyData.companyName" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="批次号：" prop="batchNumber">
              <el-input placeholder="请输入内容" v-model="modifyData.batchNumber" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="运单编号：" prop="waybillNo">
              <el-input placeholder="请输入内容" v-model="modifyData.waybillNo" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="车架号：" prop="frameNumber">
              <el-input placeholder="请输入内容" v-model="modifyData.frameNumber" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="税率：" prop="taxRate">
              <el-input placeholder="请输入内容" v-model="modifyData.taxRate" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="含税单价：" prop="taxPrice">
              <el-input placeholder="请输入内容" v-model="modifyData.taxPrice" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="对账调整含税价格：" prop="taxAdjustPrice">
              <el-input placeholder="请输入内容" v-model="modifyData.taxAdjustPrice" size="mini" />
            </el-form-item>
            <el-form-item label="是否生成对账单：" prop="isReconciliation">
              <el-input placeholder="请输入内容" v-model="modifyData.isReconciliation" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="对账单标题：" prop="actTitle">
              <el-input placeholder="请输入内容" v-model="modifyData.actTitle" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="对账单编号：" prop="actNo">
              <el-input placeholder="请输入内容" v-model="modifyData.actNo" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="录入人员：" prop="createBy">
              <el-input placeholder="请输入内容" v-model="modifyData.createBy" size="mini" :disabled="true" />
            </el-form-item>
            <el-form-item label="创建时间：" prop="createdTime">
              <el-input placeholder="请输入内容" v-model="modifyData.createdTime" size="mini" :disabled="true" />
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="editLoad" @click="onClickEditSure">确认 </el-button>
            <el-button size="medium" class="resetBtn">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="生成对账单" :visible.sync="dialogVisibleGenerateStatementAccount" width="950px" center @close="dialogGenerateStatementAccountClose">
      <div class="consignorAccount">
        <div class="center">
          <template slot="label">
            <!-- 插槽 -->
            <slot name="label"></slot>
          </template>
          <div class="information">
            <el-form :model="informationData" label-width="120px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-row>
                <el-col :span="14">
                  <el-form-item label="对账调整金额:" label-width="120px">
                    {{ informationData.taxAdjustPrice }}
                  </el-form-item>
                </el-col>
                <el-col :span="10"> </el-col>
              </el-row>
              <el-form-item label="标题:" prop="title" label-width="120px">
                <el-input size="mini" placeholder="请输入对账单标题" v-model="informationData.title"></el-input>
              </el-form-item>
              <el-form-item label="税率:" prop="taxRate" label-width="120px" v-if="$route.path == '/settle/discount'">
                <el-input size="mini" placeholder="请输入税率" v-model="informationData.taxRate" type="number"></el-input>
              </el-form-item>
              <el-form-item label="备注:" label-width="120px">
                <el-input size="mini" placeholder="请输入备注" :autosize="{ minRows: 5, maxRows: 10 }" v-model="informationData.remark" style="width: 90%" type="textarea"></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 80px">
                <el-button type="primary" size="mini" @click="onClickAddGenerateStatementAccount">确认</el-button>
                <el-button type="info" size="mini">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 提交对账单 -->
    <el-dialog title="提交对账单" :visible.sync="billDialogVisible" center :before-close="dialogBillClose" :close-on-click-modal="false">
      <div class="nav" style="margin-bottom: 10px">
        <div class="navContainer">
          <p style="width: 120px; display: inline-block; text-align: right">对账单编号：</p>
          <el-input v-model="billData.settNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
        </div>
        <div class="navContainer" style="margin-right: 10px">
          <p style="width: 60px; display: inline-block; text-align: right">标题：</p>
          <el-input v-model="billData.title" size="mini" style="width: 120px" placeholder="请输入标题" />
        </div>
        <div class="navBtn" style="display: flex; justify-content: flex-end">
          <el-button size="small" class="searchBtn" @click="billSearchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="billResetBtn">重置</el-button>
          <el-button size="small" class="submit" @click="submit">确认</el-button>
        </div>
      </div>
      <div class="tableContent">
        <el-table ref="billRef" :data="billTable.table" v-loading="billTableLoad" style="width: 100%" border :header-cell-style="headerCellStyle" highlight-current-row @current-change="handleCurrentChange">
          <el-table-column align="center" width="50px">
            <template v-slot="{ row, $index }">
              <el-radio v-model="radioId" :label="row.id" @change="val => handleChange(val, row.id)">&nbsp; </el-radio>
            </template>
          </el-table-column>
          <el-table-column property="settNo" align="center" label="对账单编号" width="139"></el-table-column>
          <el-table-column property="title" align="center" label="标题" width="130"></el-table-column>
          <el-table-column property="companyNameNew" align="center" label="公司" width="140"></el-table-column>
          <el-table-column label="合计含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.taxPrice }}</span>
                <span v-else-if="scope.row.settType === 2">{{ scope.row.taxSettPrice }}</span>
                <span v-else>{{ scope.row.taxPrice != null && scope.row.taxPrice > 0 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合计不含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.noTaxPrice }}</span>
                <span v-else>{{ scope.row.noTaxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 10px">
        <span>共{{ billDataTotal }}条</span>
        <el-pagination :page-sizes="[100, 200, 300, 400]" :page-size="100" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
      </div>
    </el-dialog>
    <portWarehouse v-if="type === 1"></portWarehouse>
  </div>
</template>

<script>
  import RecordAdjustForm from './components/recordAdjustForm';
  import newDialog from './components/newDialog.vue';
  import batchImport from '@/components/batchImport';
  import portWarehouse from './portWarehouse.vue'
  import {
    getAdjustPageList,
    updateReconciliationAdjustment,
    deleteReconciliationAdjustment,
    addGenerateStatementAccount,
    getReconciliation,
    sureSubmitReconciliation,
    cancelSubmitReconciliation,
    generate,
    getSupperAdjustPageList
  } from '@/service/financial';

  export default {
    name: 'supplierSpecialPrice',
    components: { RecordAdjustForm, newDialog, batchImport ,portWarehouse},
    data() {
      return {
        importUrl: '/customer/adjust/import',
        batchImport: '/customer/supperAdjust/import',
        importLoading: false,
        billDataTotal: 0,
        billTable: {
          table: [],
          title: '',
        },
        radioId: '',
        billTableLoad: false,
        billData: {
          adjustId: '',
          settNo: '',
          title: '',
          companyNameNew: '',
          companyName: '',
          settlementId: '', //行数据id
          page: 1,
          size: 10,
        },
        billDialogVisible: false,
        rules: {
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          title: {
            required: true,
            message: '请输入对账单标题',
            trigger: 'blur',
          },
          isInvoicing: {
            required: true,
            message: '请选择是否抵扣开票',
            trigger: 'blur',
          },
          instruction: {
            required: true,
            message: '请选择抵扣费用数据',
            trigger: 'blur',
          },
          Deductible: {
            required: true,
            message: '请输入抵扣费用',
            trigger: 'blur',
          },
        },
        informationData: {},
        editLoad: false,
        formLoadingEdit: false,
        dialogVisibleGenerateStatementAccount: false,
        dialogVisibleEdit: false,
        type:0,
        searchForm: {

          title: '',
          waybillNo: '',
          frameNumber: '',
          page: 1,
          rows: 10,
        },
        planDate: [],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        selectTable: [],
        modifyData: {},
        currentRow: null,
      };
    },
    methods: {
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.searchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      typeFun(val){
        this.type = val
        this.tableData = []
      },
      created() {
      },
      download() {
        window.exportExcelAll('get', '/customer/adjust/export', {});
      },
      exportData() {
        window.exportExcelAllFunc({
          type: 'get',
          url: '/customer/adjust/exportAdjust',
          obj:this.searchForm
        })
      },
      async generateDeductionFees() {
        // this.selectTable.map(item => item.id).join(',')
        if (this.selectTable.length > 0) {
          const res = await generate({ids: this.selectTable.map(item => item.id).join(',') })
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.searchBtn();
        } else {
          this.$message.warning('请选择至少一个对账！');
        }

      },
      cancelReferClick(id) {
        this.$confirm('确定要取消对账吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelSubmitReconciliation({ id: id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      billResetBtn() {
        this.billData.settNo = '';
        this.billData.title = '';
        this.currentRow = null;
        console.log(this.$refs.billRef);
        this.radioId = '';
      },
      submit() {
        this.$confirm(`确认选择该对账单？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await sureSubmitReconciliation({ adjustId: this.billData.adjustId, settlementId: this.currentRow.id });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.dialogBillClose();
          // await this.expensepaging();
          this.searchBtn();
        });
      },
      async billSearch() {
        this.billTableLoad = true;
        let obj = {
          companyName: this.billData.companyName,
          settNo: this.billData.settNo,
          title: this.billData.title,
          page: 1,
          size: 10,
        };
        const res = await getReconciliation(obj);
        this.billTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.billTable.table = res.data.records;
        this.billDataTotal = res.data.total;
      },
      billSearchBtn() {
        this.billSearch();
      },
      onClickSubmitReconciliation(row) {
        this.billData.adjustId = row.id;
        this.billData.companyName = row.companyName;
        this.billDialogVisible = true;
      },
      billCurrentChange(page) {
        this.billData.page = page;
      },
      billSizeChange(sizes) {
        this.billData.size = sizes;
      },
      handleChange(id, idx) {
        this.id = idx;
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      dialogBillClose() {
        // console.log('<<<');
        this.billResetBtn();
        this.billTable.table = [];
        this.billDialogVisible = false;
      },
      async onClickAddGenerateStatementAccount() {
        // console.log(this.informationData);
        // console.log(this.selectTable);
        const res = await addGenerateStatementAccount({
          ...this.informationData,
          type: this.selectTable[0]['type'] == 1 || this.selectTable[0]['type'] == 2 || this.selectTable[0]['type'] == 10 ? 28 : 29,
          adjustIds: this.selectTable.map(item => item.id).join(','),
          settIds: this.selectTable.map(item => item.id).join(','),
          companyNameNew: this.selectTable[0]['companyName'],
          setType: this.selectTable[0]['setType'],
        });
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this.dialogVisibleGenerateStatementAccount = false;
      },
      onClickGenerateStatementAccount() {
        if (this.selectTable.length == 0) {
          this.$message.warning('请选择一个！');
          return;
        }
        // console.log(this.selectTable);
        let ele = null;
        let flag = true;
        let addUp = 0;
        if (this.selectTable.length > 1) {
          this.selectTable.forEach((element, i) => {
            addUp += element.taxAdjustPrice;
            if (i == 0) {
              ele = element['type'];
            } else {
              if (element['type'] != ele) {
                flag = false;
              }
            }
          });
        } else {
          addUp = this.selectTable[0]['taxAdjustPrice'];
        }
        if (flag) {
          this.dialogVisibleGenerateStatementAccount = true;
          this.informationData = {};
          this.informationData['taxAdjustPrice'] = addUp;
        } else {
          this.$message.warning('请选择同一个类型！');
        }
      },
      dialogGenerateStatementAccountClose() {},
      onClickBtnDeletes() {
        // console.log(this.selectTable);
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteReconciliationAdjustment({ id: this.selectTable.map(item => item.id).join(',') });
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      async onClickDelete(id) {
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteReconciliationAdjustment({ id });
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      async onClickEditSure() {
        // console.log(this.modifyData);
        const res = await updateReconciliationAdjustment(this.modifyData);
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        // this.newDialogVisible = false;
        this.getTableData();
        this.dialogVisibleEdit = false;
      },
      onClickEdit(row) {
        this.modifyData = row;
        this.dialogVisibleEdit = true;
      },
      dialogCloseEdit() {},
      newBtn() {
        this.$refs.newDialogRef.openDialog();
      },
      // 对账调整
      recordAdjust() {
        if (this.selectTable.length === 0) return this.$message.warning('请选择数据后添加结算！');
        this.$refs.recordAdjustFormRef.dialogOpen(this.selectTable);
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await getAdjustPageList(this.searchForm);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      rowStyle({ row }) {
        return this.selectTable.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      handleSelectionChange(val) {
        this.selectTable = val;
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 200px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }
    .nav {
      width:100%;
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .paginationContainer {
    margin-right: auto;
    display: flex;
    align-items: center;
    margin-bottom: 0px;

    span {
      font-size: 13px;
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }
</style>
